import { createContext } from '@lit/context';
import { Producer } from '../util/api';

export const agentContext = createContext<Producer | undefined>(Symbol('agent'));
